import React from 'react';
import Router from './Router/Router';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
